import { Link } from "react-router-dom";

export const Logo = ({ light = false, full = false, className = "h-10" }) => {
  const src = `/brand/logo${full ? "" : "-compact"}${light ? "-light" : ""}.png`;
  return (
    <Link to="/" aria-label="Industrix Solution home" data-testid={light ? "footer-logo" : "header-logo"} className="inline-flex shrink-0 items-center">
      <img src={src} alt="Industrix Solution logo" width={full ? 1949 : 900} height={full ? 602 : 227} className={`${className} w-auto`} />
    </Link>
  );
};
